import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh" gap={2}>
      <Typography variant="h3" color="error">
        403
      </Typography>
      <Typography variant="h5">{t('common.unauthorized.message')}</Typography>
      <Typography variant="body2" color="text.secondary">
        {t('common.unauthorized.contactAdmin')}
      </Typography>
      <Button variant="contained" onClick={() => navigate(-1)}>
        {t('common.back')}
      </Button>
    </Box>
  );
};
